import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-754556b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column-cell" }
const _hoisted_2 = { class: "column-cell" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    value: _ctx.mappingFields,
    loading: _ctx.loading,
    class: "p-datatable-sm p-datatable-documents",
    autoLayout: true,
    columnResizeMode: "fit",
    rowHover: true,
    paginator: true,
    rows: _ctx.tableListPagination.pageSize,
    paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
    rowsPerPageOptions: [25,50,100],
    currentPageReportTemplate: '{first} ' + _ctx.$t('Squeeze.General.To') + ' {last} ' + _ctx.$t('Squeeze.General.Of') + ' {totalRecords}  ',
    scrollable: true,
    scrollHeight: "flex",
    removableSort: true,
    filterDisplay: "row",
    onPage: _ctx.onChangePage,
    filters: _ctx.filters,
    "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
    onFilter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFilter($event))),
    sortMode: "multiple"
  }, {
    loading: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.Loading')), 1)
    ]),
    empty: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.NoEntriesFound', { entryName: _ctx.$t('Squeeze.XmlMapper.HeadData') })), 1)
    ]),
    paginatorstart: _withCtx(() => [
      _createVNode(_component_Button, {
        label: _ctx.$t('Squeeze.General.NewEntry'),
        type: "button",
        icon: "mdi mdi-plus",
        class: "p-button p-mr-2",
        onClick: _ctx.onNewEntryClick
      }, null, 8, ["label", "onClick"]),
      (_ctx.showGlobalEntries)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: _ctx.$t('Squeeze.XmlMapper.HideGlobalMapping'),
            type: "button",
            icon: "mdi mdi-minus",
            class: "p-button p-mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickShowGlobal(false)))
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      (!_ctx.showGlobalEntries)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            label: _ctx.$t('Squeeze.XmlMapper.ShowGlobalMapping'),
            type: "button",
            icon: "mdi mdi-plus",
            class: "p-button p-mr-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickShowGlobal(true)))
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    paginatorend: _withCtx(() => []),
    default: _withCtx(() => [
      false
        ? (_openBlock(), _createBlock(_component_Column, {
            key: 0,
            field: "id",
            header: "ID",
            sortable: false,
            filterMatchMode: "contains",
            style: {"min-width":"4rem","max-width":"6rem"}
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Column, {
        field: "company",
        filterField: "company",
        header: _ctx.$t('Squeeze.XmlMapper.Company'),
        sorted: true,
        sortable: true,
        showFilterMenu: false,
        style: {"min-width":"4rem"}
      }, {
        filter: _withCtx(({filterModel, filterCallback}) => [
          _createVNode(_component_InputText, {
            style: {"min-width":"4rem"},
            class: "p-column-filter filter-field",
            type: "text",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "creditor",
        header: _ctx.$t('Squeeze.XmlMapper.Creditor'),
        sortable: true,
        showFilterMenu: false,
        filterMatchMode: "contains",
        style: {"min-width":"7rem"}
      }, {
        filter: _withCtx(({filterModel, filterCallback}) => [
          _createVNode(_component_InputText, {
            style: {"min-width":"4rem"},
            class: "p-column-filter filter-field",
            type: "text",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "documentclassid",
        header: _ctx.$t('Squeeze.DocumentClasses.DocumentClass'),
        sortable: true,
        showClearButton: false,
        showFilterMenu: false,
        filterMatchMode: "contains",
        style: {"min-width":"7rem"}
      }, {
        body: _withCtx((slotProp) => [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.getDescription(slotProp.data)), 1)
          ])), [
            [
              _directive_tooltip,
              _ctx.getDescription(slotProp.data),
              void 0,
              { bottom: true }
            ]
          ])
        ]),
        filter: _withCtx(({filterModel, filterCallback}) => [
          _createVNode(_component_Dropdown, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            onChange: ($event: any) => (filterCallback()),
            options: _ctx.documentClasses,
            class: "p-column-filter filter-field",
            optionValue: "id",
            optionLabel: "description",
            showClear: true,
            filter: true,
            autoFilterFocus: true,
            style: {"min-width":"9rem"}
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "options"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "fieldName",
        "filter-field": "fieldName",
        header: _ctx.$t('Squeeze.XmlMapper.FieldName'),
        sortable: true,
        showFilterMenu: false,
        style: {"min-width":"12rem"}
      }, {
        body: _withCtx((slotProp) => [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.getFieldDescription(slotProp.data)), 1)
          ])), [
            [
              _directive_tooltip,
              _ctx.getFieldDescriptionTooltip(slotProp.data),
              void 0,
              { bottom: true }
            ]
          ])
        ]),
        filter: _withCtx(({filterModel, filterCallback}) => [
          _createVNode(_component_Dropdown, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            onChange: ($event: any) => (filterCallback()),
            options: _ctx.documentClassFields,
            class: "p-column-filter filter-field",
            optionValue: "name",
            optionLabel: _ctx.getFieldDescriptionDropDown,
            showClear: true,
            filter: true,
            autoFilterFocus: true,
            style: {"min-width":"9rem"}
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "options", "optionLabel"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "xpath",
        header: _ctx.$t('Squeeze.XmlMapper.XPath'),
        sortable: true,
        showFilterMenu: false,
        filterMatchMode: "contains",
        style: {"min-width":"10rem"}
      }, {
        body: _withCtx((slotProp) => [
          _withDirectives((_openBlock(), _createElementBlock("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createPrintableXpath(slotProp.data.xpath), (xPath, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(xPath.indentation, (indexIndent) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: indexIndent }, [
                    _createTextVNode("       ")
                  ], 64))
                }), 128)),
                _createTextVNode(" " + _toDisplayString(xPath.xPathPart) + " ", 1),
                (index === _ctx.createPrintableXpath(slotProp.data.xpath).length -1)
                  ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: "mdi mdi-content-copy",
                      type: "button",
                      class: "p-button p-button-lg p-button-rounded p-button-text buttonCopy",
                      style: {"height":"1.0rem"},
                      onClick: ($event: any) => (_ctx.copyToClipboard(_ctx.$t, _ctx.$toast, slotProp.data.xpath))
                    }, null, 8, ["onClick"])), [
                      [
                        _directive_tooltip,
                        _ctx.$t('Squeeze.General.CopyToClipboard'),
                        void 0,
                        { top: true }
                      ]
                    ])
                  : _createCommentVNode("", true),
                _hoisted_3
              ], 64))
            }), 128))
          ])), [
            [
              _directive_tooltip,
              slotProp.data.xpath,
              void 0,
              { bottom: true }
            ]
          ])
        ]),
        filter: _withCtx(({filterModel, filterCallback}) => [
          _createVNode(_component_InputText, {
            style: {"min-width":"4rem"},
            class: "p-column-filter filter-field",
            type: "text",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, { style: {"min-width":"7rem","max-width":"7rem","text-align":"right"} }, {
        body: _withCtx((slotProps) => [
          (!slotProps.data.readonly)
            ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                key: 0,
                icon: "mdi mdi-pencil-outline",
                class: "p-button-lg p-button-rounded p-button-success p-button-text",
                onClick: ($event: any) => (_ctx.openEditDialog(slotProps.data))
              }, null, 8, ["onClick"])), [
                [
                  _directive_tooltip,
                  _ctx.$t('Squeeze.Locators.Edit'),
                  void 0,
                  { bottom: true }
                ]
              ])
            : _createCommentVNode("", true),
          (!slotProps.data.readonly)
            ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                key: 1,
                icon: "mdi mdi-delete-outline",
                class: "p-button-lg p-button-rounded p-button-danger p-button-text",
                onClick: ($event: any) => (_ctx.openDeleteDialog(slotProps.data))
              }, null, 8, ["onClick"])), [
                [
                  _directive_tooltip,
                  _ctx.$t('Squeeze.Validation.Buttons.Delete'),
                  void 0,
                  { bottom: true }
                ]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value", "loading", "rows", "currentPageReportTemplate", "onPage", "filters"]))
}